import { render } from "./TalentPoolStats.vue?vue&type=template&id=1bc9e4b6"
import script from "./TalentPoolStats.vue?vue&type=script&lang=js"
export * from "./TalentPoolStats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__